<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->
<div class="background-image h-full">
  <myprofile-signup-ui-navigation navMode="hero" navTheme="dark"></myprofile-signup-ui-navigation>
  <div class="grid-template">
    <main id="main-content" class="col-extended pb-fluid-lg">
      <!-- *ngIf="true" hack is required here for router-outlet to work correctly. Otherwise,
      it won't register the changes on the layout and won't update the view. -->
      @if (true) {
        <router-outlet></router-outlet>
      }
    </main>
  </div>
</div>
